import { ContentContainer, useDebouncedSearch } from '@gorila-shared-ui/components';
import { useState } from 'react';
import { GpsType } from '../../../types/device';
import { DevicesFiltersBar } from '../../devices/DevicesFiltersBar';
import { DevicesList } from '../../devices/DevicesList';
import DeviceCarrierProvider from '../../providers/DeviceCarrierProvider';

export function DevicesPage() {
  const { search, setSearch, trigger: debouncedSearch } = useDebouncedSearch('');
  const [reloadPage, setReloadPage] = useState(false);
  const [gpsType, setGpsType] = useState<GpsType>();

  return (
    <ContentContainer>
      <DeviceCarrierProvider />
      <DevicesFiltersBar
        search={search}
        onChangeSearch={setSearch}
        onReloadPage={() => setReloadPage(!reloadPage)}
        gpsType={gpsType}
        setGpsType={setGpsType}
      />
      <DevicesList
        search={debouncedSearch}
        reloadPage={reloadPage}
        gpsType={gpsType}
      />
    </ContentContainer>
  );
}
